import { BehaviorSubject, Subject } from 'rxjs';
import { GameServices } from '../../services/game-services';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { BlocksStylesType, BlocksTranslationsType } from '../../model/blocks-types';
import { getGameMetrics } from 'src/games/phaserblocks/logic/helpers/game-metrics';

export class LevelControlViewModel {
  public get levelLabelText() {
    return this.gameServices.gameTranslationService.getTranslation(BlocksTranslationsType.Level);
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get blocksLogicActionBus$() {
    return this.gameServices.gameRunnerService.blocksLogicActionBus$;
  }
  public get onGameSetupStart$() {
    return this.gameServices.gameRunnerService.onGameSetupStartTrigger;
  }
  public get onResetGameScene$() {
    return this.onResetGameScene;
  }
  public get maxStage$() {
    return this.maxStage;
  }
  public get currentMaxStage() {
    return this.maxStage.value;
  }
  public get showControl$() {
    return this.showControl.asObservable();
  }
  public get defaultFontFamily() {
    return this.gameServices.gameThemeService.defaultFontFamily;
  }
  public get primaryLabelFill() {
    return this.gameServices.gameThemeService.getHexColor(BlocksStylesType.PrimaryLabelFill);
  }
  public get secondaryLabelFill() {
    return this.gameServices.gameThemeService.getHexColor(BlocksStylesType.SecondaryLabelFill);
  }

  private readonly onResetGameScene = new Subject<void>();
  private readonly showControl = new BehaviorSubject<boolean>(false);
  private readonly maxStage: BehaviorSubject<string>;

  constructor(private gameServices: GameServices) {
    this.maxStage = new BehaviorSubject<string>(this.fetchMaxStage());
  }

  public calculateScaleFactor(gameSizeMetrics: GameSizeMetrics): {
    scaledOffsetX: number;
    scaleFactor: number;
  } {
    return this.gameServices.gameMetricsService.calculateBoardScaling(gameSizeMetrics);
  }

  public onGameSetupStart() {
    this.maxStage.next(this.fetchMaxStage());
    this.showControl.next(true);
  }

  public resetGameScene() {
    this.onResetGameScene.next();
    this.showControl.next(false);
    this.maxStage.next(this.fetchMaxStage());
  }

  private fetchMaxStage(): string {
    const logicVersion = this.gameServices.gameRunnerService.currentGame?.logicVersion ?? 1;
    const gameMetrics = getGameMetrics(logicVersion);
    return `${gameMetrics.MaxStage - 1}`;
  }
}
